"use client";

import React, { Suspense } from "react";
import EventTicker from "@/components/common/EventTicker";
import GlobalFooter from "@/components/common/newCommonComponent/GlobalFooter";
import GlobalHeaderNew from "@/components/common/newCommonComponent/GlobalHeaderNew";
import dynamic from "next/dynamic";
import InfoTicker from "@/components/newPageComponent/cpa-new/course/InforTicket";
import CMACourseBanner from "@/components/newPageComponent/cma-new/cma-course/CMACourseBanner";
import WhatCmaCourse from "@/components/newPageComponent/cma-new/cma-course/WhatCmaCourse";
import CmaCourseDetailsNew from "@/components/newPageComponent/cma-new/cma-course/CmaCourseDetailsNew";
import CmaSyllabusSubject from "@/components/newPageComponent/cma-new/cma-course/CmaSyllabusSubject";
import CmaCoursePattern from "@/components/newPageComponent/cma-new/cma-course/CmaCoursePattern";
import CmaCourseEligibility from "@/components/newPageComponent/cma-new/cma-course/CmaCourseEligibility";
import CmaCourseFee from "@/components/newPageComponent/cma-new/cma-course/CmaCourseFee";
import CmaCourseAI from "@/components/newPageComponent/cma-new/cma-course/CmaCourseAI";
import CmaCourseCareer from "@/components/newPageComponent/cma-new/cma-course/CmaCourseCareer";
import CmaCourseInstitute from "@/components/newPageComponent/cma-new/cma-course/CmaCourseInstitute";
import CmaCourseFaq from "@/components/newPageComponent/cma-new/cma-course/CmaCourseFaq";
import { SectionSkeleton } from "@/components/common/LoadingSkeleton";
import StickyFooter from "@/components/newPageComponent/CommonSection/StickyFooter";
import PreferredSourceBanner from "@/components/blogs/PreferredSourceBanner";
const NewInactivityPopup = dynamic(
  () =>
    import("@/components/newPageComponent/CommonSection/NewInactivityPopup"),
  { ssr: false },
);

const DesktopPage: React.FC = () => {
  return (
    <>
      <div className="w-full bg-white">
        <EventTicker />
        <GlobalHeaderNew />
        <CMACourseBanner />
        <InfoTicker
          items={[
            {
              highlight: "100+",
              suffix: "  University Partners",
            },
            { highlight: "600+", suffix: " Employer Collaborations" },
            { highlight: "1,000+", suffix: " Students Placed in the U.S." },
            { highlight: "70,000+", suffix: " Global Alumni" },
            { highlight: "", suffix: " Global Career Pathways" },
          ]}
        />
        <WhatCmaCourse />
        <CmaCourseDetailsNew />
        <PreferredSourceBanner />
        <CmaSyllabusSubject />
        <CmaCoursePattern />
        <CmaCourseEligibility />
        <CmaCourseFee />
        <CmaCourseAI />
        <CmaCourseCareer />
        <CmaCourseInstitute />
        <CmaCourseFaq />
        <Suspense fallback={<SectionSkeleton />}>
          <GlobalFooter />
        </Suspense>
        <Suspense fallback={<SectionSkeleton />}>
          <StickyFooter pageName="CMA" courseID={2} />
        </Suspense>
        <NewInactivityPopup pageName="CMA" courseId={2} delay={7000} />
      </div>
    </>
  );
};

export default DesktopPage;
